import { useEffect } from "react";

const BASE = "https://www.syndicappli360.com";

export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", `${BASE}${path}`);
  }, [title, description, path]);

  return null;
};
